var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__a)",
    fillRule: "evenodd",
    d: "M10.53 3.757a1 1 0 0 1 1.962.37l-.021.116-.5 2a1 1 0 0 1-1.962-.37l.021-.116zm-4.537.126A1 1 0 0 0 4 4l-.117.007A1 1 0 0 0 4 6l.007.117A1 1 0 0 0 6 6l.117-.007A1 1 0 0 0 6 4zM21 5a1 1 0 0 0-1-1l-.007-.117A1 1 0 0 0 18 4l-.117.007A1 1 0 0 0 18 6l.007.117A1 1 0 0 0 20 6l.117-.007A1 1 0 0 0 21 5m-5.293 3.293a1 1 0 0 0-1.414 0l-1 1-.083.094a1 1 0 0 0 1.497 1.32l1-1 .083-.094a1 1 0 0 0-.083-1.32m4.051 3.237a1 1 0 0 1 .597 1.905l-.112.035-2 .5a1 1 0 0 1-.596-1.905l.111-.035zM21 19a1 1 0 0 0-1-1l-.007-.117A1 1 0 0 0 18 18l-.117.007A1 1 0 0 0 18 20l.007.117A1 1 0 0 0 20 20l.117-.007A1 1 0 0 0 21 19M6.573 9.583l-4.39 9.58a2.003 2.003 0 0 0 2.654 2.656l9.58-4.39a1 1 0 0 0 .575-.782l.008-.129a1 1 0 0 0-.292-.707L8.19 9.293a1 1 0 0 0-1.617.29m1.218 2.141 4.484 4.484-8.273 3.79z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__a",
    x1: 11.501,
    x2: 11.501,
    y1: 22,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgConfetti;